import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AdaState } from '@core/ada/store/states/ada.state';
import {
  MarkMessagesAsUnread,
  ResetConversation,
  SetAdaEmbedAsLoaded,
  SetChatAsInitialized,
  UpdateAdaChatToggleState,
} from '@core/ada/store/actions/ada.actions';
import { ResetStateFacade } from '@core/store/facades/reset-state.facade';

@Injectable({
  providedIn: 'root',
})
export class AdaFacade {
  private readonly store = inject(Store);
  private readonly resetStateFacade = inject(ResetStateFacade);

  readonly isAdaEmbedLoaded = this.store.selectSignal(AdaState.isAdaEmbedLoaded);
  readonly isChatOpened = this.store.selectSignal(AdaState.isChatOpened);
  readonly hasUnreadMessages = this.store.selectSignal(AdaState.hasUnreadMessages);
  readonly isChatInitialized = this.store.selectSignal(AdaState.isChatInitialized);

  updateChatToggleState(isOpened: boolean): void {
    this.store.dispatch(new UpdateAdaChatToggleState(isOpened));
  }

  markMessagesAsUnread(): void {
    this.store.dispatch(new MarkMessagesAsUnread());
  }

  setAdaEmbedAsLoaded(): void {
    this.store.dispatch(new SetAdaEmbedAsLoaded());
  }

  setChatAsInitialized(): void {
    this.store.dispatch(new SetChatAsInitialized());
  }

  resetConversation(): void {
    this.store.dispatch(new ResetConversation());
  }

  clearState(): void {
    this.resetStateFacade.clearState(AdaState);
  }
}
